 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import FRONT_MATTER from '@/components/front_matter'
 import HALFTITLE from '@/components/halftitle'
 import LOVE_1 from '@/components/love_1'
 import TITLE_PAGE from '@/components/title_page'
 import COPYRIGHT from '@/components/copyright'
 import DEDICATION from '@/components/dedication'
 import TOC from '@/components/toc'
 import FOREWORD from '@/components/foreword'
 import ACK from '@/components/ack'
 import INTRODUCTION from '@/components/introduction'
 import CHAP01 from '@/components/chap01'
 import CHAP01FIG01 from '@/components/chap01fig01'
 import CHAP01A from '@/components/chap01a'
 import CHAP01FIG02 from '@/components/chap01fig02'
 import CHAP01B from '@/components/chap01b'
 import CHAP02 from '@/components/chap02'
 import CHAP02FIG01 from '@/components/chap02fig01'
 import CHAP02A from '@/components/chap02a'
 import CHAP02FIG02 from '@/components/chap02fig02'
 import CHAP02B from '@/components/chap02b'
 import CHAP02FIG03 from '@/components/chap02fig03'
 import CHAP02C from '@/components/chap02c'
 import CHAP03 from '@/components/chap03'
 import CHAP04 from '@/components/chap04'
 import CHAP04FIG01 from '@/components/chap04fig01'
 import CHAP04A from '@/components/chap04a'
 import CHAP04FIG02 from '@/components/chap04fig02'
 import CHAP04B from '@/components/chap04b'
 import CHAP04FIG03 from '@/components/chap04fig03'
 import CHAP04C from '@/components/chap04c'
 import CHAP04FIG04 from '@/components/chap04fig04'
 import CHAP04D from '@/components/chap04d'
 import CHAP04FIG05 from '@/components/chap04fig05'
 import CHAP04E from '@/components/chap04e'
 import CHAP04FIG06 from '@/components/chap04fig06'
 import CHAP04F from '@/components/chap04f'
 import CHAP05 from '@/components/chap05'
 import CHAP05FIG01 from '@/components/chap05fig01'
 import CHAP05A from '@/components/chap05a'
 import CHAP05FIG02 from '@/components/chap05fig02'
 import CHAP05B from '@/components/chap05b'
 import CHAP05FIG04 from '@/components/chap05fig04'
 import CHAP05C from '@/components/chap05c'
 import CHAP05FIG05 from '@/components/chap05fig05'
 import CHAP05FIG06 from '@/components/chap05fig06'
 import CHAP05D from '@/components/chap05d'
 import CHAP05FIG07 from '@/components/chap05fig07'
 import CHAP05FIG08 from '@/components/chap05fig08'
 import CHAP05E from '@/components/chap05e'
 import CHAP05FIG09 from '@/components/chap05fig09'
 import CHAP05F from '@/components/chap05f'
 import CHAP05FIG10 from '@/components/chap05fig10'
 import CHAP05G from '@/components/chap05g'
 import CHAP06 from '@/components/chap06'
 import CHAP06FIG1 from '@/components/chap06fig1'
 import CHAP06A from '@/components/chap06a'
 import CHAP06FIG2 from '@/components/chap06fig2'
 import CHAP06B from '@/components/chap06b'
 import CHAP06FIG3 from '@/components/chap06fig3'
 import CHAP06C from '@/components/chap06c'
 import CHAP06FIG4 from '@/components/chap06fig4'
 import CHAP06D from '@/components/chap06d'
 import CHAP07 from '@/components/chap07'
 import CHAP07FIG1 from '@/components/chap07fig1'
 import CHAP07A from '@/components/chap07a'
 import CHAP07FIG2 from '@/components/chap07fig2'
 import CHAP07B from '@/components/chap07b'
 import CHAP07FIG3 from '@/components/chap07fig3'
 import CHAP07C from '@/components/chap07c'
 import CHAP08 from '@/components/chap08'
 import CHAP08FIG1 from '@/components/chap08fig1'
 import CHAP08A from '@/components/chap08a'
 import CHAP09 from '@/components/chap09'
 import CHAP10 from '@/components/chap10'
 import LOVE_2 from '@/components/love_2'
 import RESOURCES from '@/components/resources'
 import INDEX from '@/components/index'
 import ABOUT_THE_AUTHOR from '@/components/about_the_author'
 import BACK01 from '@/components/back01'
 import BACK02 from '@/components/back02'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/toc",
 			"name" : "toc",
 			"component" : TOC
 		},
 		{
 			"path" : "/foreword",
 			"name" : "foreword",
 			"component" : FOREWORD
 		},
 		{
 			"path" : "/ack",
 			"name" : "ack",
 			"component" : ACK
 		},
 		{
 			"path" : "/introduction",
 			"name" : "introduction",
 			"component" : INTRODUCTION
 		},
 		{
 			"path" : "/chap01",
 			"name" : "chap01",
 			"component" : CHAP01
 		},
 		{
 			"path" : "/chap01fig01",
 			"name" : "chap01fig01",
 			"component" : CHAP01FIG01
 		},
 		{
 			"path" : "/chap01a",
 			"name" : "chap01a",
 			"component" : CHAP01A
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js